import React from 'react';
import Page1CouvertureLevage from './pdf-levage/Page1CouvertureLevage';
import Page2CaracteristiquesSuite from './pdf-levage/Page2CaracteristiquesSuite';
import Page3DocumentationEssais from './pdf-levage/Page3DocumentationEssais';
import AnnexesLevageImages from './pdf-levage/AnnexesLevageImages';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'white',
    zIndex: 2000,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  toolbar: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    zIndex: 100,
  },
  toolbarBtn: {
    padding: '10px 16px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  printBtn: {
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    color: 'white',
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.2)',
    color: 'white',
  },
  page: {
    width: '210mm',
    minHeight: '297mm',
    margin: '20px auto',
    padding: '15mm 12mm',
    background: 'white',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    boxSizing: 'border-box',
    fontFamily: 'Arial, sans-serif',
    fontSize: '11px',
    lineHeight: 1.4,
    pageBreakAfter: 'always',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '20px',
    paddingBottom: '15px',
    borderBottom: '3px solid #f59e0b',
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    color: '#92400e',
    marginBottom: '4px',
  },
  subtitle: {
    fontSize: '12px',
    color: '#6b7280',
  },
  section: {
    marginBottom: '18px',
  },
  sectionTitle: {
    fontSize: '12px',
    fontWeight: 700,
    color: 'white',
    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    padding: '6px 10px',
    marginBottom: '8px',
    borderRadius: '4px',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px',
  },
  infoRow: {
    display: 'flex',
    padding: '6px 10px',
    background: '#f8fafc',
    borderRadius: '4px',
    borderLeft: '3px solid #f59e0b',
  },
  infoLabel: {
    fontWeight: 600,
    color: '#334155',
    minWidth: '120px',
  },
  infoValue: {
    color: '#1e293b',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '10px',
  },
  th: {
    padding: '8px 6px',
    textAlign: 'left',
    fontWeight: 600,
    background: '#fde68a',
    border: '1px solid #fcd34d',
    color: '#92400e',
  },
  td: {
    padding: '6px',
    border: '1px solid #e5e7eb',
    verticalAlign: 'top',
  },
  annexeImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    pageBreakInside: 'avoid',
    marginBottom: '10px',
  },
};

function RapportLevagePrintMobile({ mission, onClose }) {
  const rapport = mission?.rapport || {};
  const client = mission?.client || {};
  const parametres = mission?.parametres || {};
  const inspecteur = mission?.inspecteur || {};
  const familleCode =
    rapport?.etape_1_infos_generales_levage?.famille_machine_code ||
    rapport?.etape_2_caracteristiques_techniques_levage?.famille_machine_code ||
    'B5';

  return (
    <div style={styles.overlay}>
      <div style={styles.toolbar} className="no-print">
        <button style={{ ...styles.toolbarBtn, ...styles.closeBtn }} onClick={onClose}>
          ← Retour
        </button>
        <span style={{ color: 'white', fontWeight: 600 }}>Rapport Levage</span>
        <button
          style={{ ...styles.toolbarBtn, ...styles.printBtn }}
          onClick={() => window.print()}
        >
          🖨️ Imprimer / PDF
        </button>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          .print-page { box-shadow: none !important; margin: 0 !important; }
          .print-page:last-child { page-break-after: auto; }
        }
      `}</style>

      <div className="print-page">
        <Page1CouvertureLevage rapport={rapport} client={client} parametres={parametres} inspecteur={inspecteur} />
      </div>

      <div className="print-page">
        <Page2CaracteristiquesSuite rapport={rapport} client={client} parametres={parametres} />
      </div>

      <div className="print-page">
        <Page3DocumentationEssais rapport={rapport} client={client} parametres={parametres} />
      </div>

      <AnnexesLevageImages familleCode={familleCode} />
    </div>
  );
}

export default RapportLevagePrintMobile;
